import React, { Suspense } from "react";
import { createRoot } from 'react-dom/client';
import { createStore, applyMiddleware } from 'redux'; // Creates the Central Redux Store
import { Provider } from 'react-redux'; // Makes sure the Store is connected to React
import App from './App';
import reducer from './Reducers'; // Gets the root reducer to be used by the store
import { composeWithDevTools } from '@redux-devtools/extension';
import * as serviceWorker from './serviceWorker';
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { persistStore, persistReducer } from 'redux-persist';
import './i18n';
import { thunk } from 'redux-thunk';


const Loader = () => <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignITems: 'center' }}>loading...</div>;

const persistConfig = {
  key: 'root',
  storage: storage,
};

const pReducer = persistReducer(persistConfig, reducer);

//hook up the redux devtools browser extension
export const store = createStore(pReducer,
  composeWithDevTools(
    applyMiddleware(thunk)
  )
);

const persistor = persistStore(store);

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
  <Provider store={store}>
    <PersistGate loading={<Loader />} persistor={persistor}>
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>
    </PersistGate>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
